import type { PublicSlotKey } from '#packages/apilib';
import type { BranchesManagerApi } from './branchesManagerApi';

export const BranchesManagerKey: PublicSlotKey<BranchesManagerApi> = {
  name: 'BranchesManager',
  public: true,
};
